import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FormFieldsPerAssetType from '../shared/FormFieldsPerAssetType';

import FormError from '../../../validators/FormError';
import PresenceValidator from '../../../validators/PresenceValidator';

export default class AssetFields extends Component {

  static propTypes = {
    formFieldsToRender: PropTypes.array,
    formFieldValues: PropTypes.object,
    currencies: PropTypes.array,
    assetId: PropTypes.number,
    isRetired: PropTypes.bool,
    isLinked: PropTypes.bool,
  }

  constructor(props) {
    super(props);
    let assetNameVal = this.props.formFieldValues ? this.props.formFieldValues.assetName : '';
    let grossVal = this.props.formFieldValues ? this.props.formFieldValues.grossValue : 0;
    let monthlyContributionVal = this.props.formFieldValues ? this.props.formFieldValues.monthlyContribution : 0;
    let employerMonthlyContributionVal = this.props.formFieldValues ? this.props.formFieldValues.employerMonthlyContribution : 0;
    let monthlyIncomeVal = this.props.formFieldValues ? this.props.formFieldValues.monthlyIncome : 0;
    let assetCurrencyVal = this.props.formFieldValues ? this.props.formFieldValues.currency : '';
    let interestRate = this.props.formFieldValues ? this.props.formFieldValues.interestRate : '';
    let termOfDebt = this.props.formFieldValues ? this.props.formFieldValues.termOfDebt : '';
    let liability = this.props.formFieldValues ? this.props.formFieldValues.liability : 0;
    let baseCost = this.props.formFieldValues ? this.props.formFieldValues.baseCost : 0;

    this.state = {
      formErrors: {
        assetName: '',
      },
      fieldsValid: {
        assetName: false,
      },
      fieldValues: {
        assetName: assetNameVal,
        grossValue: grossVal,
        monthlyContribution: monthlyContributionVal,
        employerMonthlyContribution: employerMonthlyContributionVal,
        monthlyIncome: monthlyIncomeVal,
        currency: assetCurrencyVal,
        interestRate: interestRate,
        termOfDebt: termOfDebt,
        liability: liability,
        baseCost: baseCost
      },
      selectedCurrency: assetCurrencyVal || 'usd',
      currencies: this.props.currencies,
      formFieldsToRender: this.props.formFieldsToRender,
      availableFields: FormFieldsPerAssetType.AVAILABLE_FORM_FIELDS
    };
  }

  componentDidMount() {
    let assetNameValid = false;

    if (PresenceValidator.isValid(this.state.fieldValues.assetName)){
      assetNameValid = true;
    }

    this.setState({
      fieldsValid: {
        assetName: assetNameValid
      }
    }, this.props.formValidCallback(assetNameValid))

    var event = new CustomEvent('react-components-load');
    document.dispatchEvent(event);
  }

  validateInput = (fieldName, inputValue) => {
    let assetNameErrors  = this.state.formErrors.assetName;
    let grossValueErrors = this.state.formErrors.grossValue;
    let assetNameValid   = this.state.fieldsValid.assetName;

    switch(fieldName) {
      case 'assetName':
        let isAssetNameValid = PresenceValidator.isValid(inputValue);
        assetNameValid = isAssetNameValid ? true : false;
        assetNameErrors = isAssetNameValid ? '' : 'cannot be empty';
        break;
      default:
        break;
    };

    this.setState({
      formErrors: {
        assetName: assetNameErrors,
      },
      fieldsValid: {
        assetName: assetNameValid,
      },
    }, this.props.formValidCallback(assetNameValid));

  }

  renderSelectedFields(){
    const fields = this.state.formFieldsToRender;

    return fields.map((row, index) => {
      let arr = [];
      {row.forEach(col => {
        for (let fieldName in col) {
          arr.push(this.renderField(fieldName, col[fieldName]))
        }
      })}

      return (
        <div key={`asset-row-${index}`}>
          {arr}
        </div>
      );
    });
  }

  renderField(fieldName, config) {
    switch(fieldName){
      case this.state.availableFields.assetName:
        return this.nameField(config);
      case this.state.availableFields.assetCurrency:
        return this.currencyFields(config);
      case this.state.availableFields.assetGrossValue:
        return this.grossValueField(config);
      case this.state.availableFields.assetMonthlyContribution:
        return this.monthlyContributionField(config);
      case this.state.availableFields.assetEmployerMonthlyContribution:
        return this.employerMonthlyContributionField(config);
      case this.state.availableFields.assetMonthlyIncome:
        return this.monthlyIncomeField(config);
      case this.state.availableFields.assetInterestRate:
        return this.interestRateFields(config);
      case this.state.availableFields.assetBondInterestRate:
        return this.bondInterestRateFields(config);
      case this.state.availableFields.assetLiability:
        return this.liabilityFields(config);
      case this.state.availableFields.assetTermOfDebt:
        return this.termOfDebtFields(config);
      case this.state.availableFields.assetMonthlyProfit:
        return this.monthlyProfitFields(config);
      case this.state.availableFields.baseCost:
        return this.baseCostFields(config);
      default:
        return '';
    }
  }

  setSelectedCurrency = (event) => {
    this.setState({
      selectedCurrency: event.target.value
    });
  }

  isChecked = (currency) => {
    return this.state.selectedCurrency == currency
  }

  nameField(config = {}){
    return (
      <div key='asset-name' className={`${config.classNames} form-input string optional asset_name`}>
        <label className="form-control asset_name">
          <div className="form-control__label">
            <span>Give your asset a name</span>
          </div>
          <div className="form-control__input">
            <input onChange={(e)=>this.validateInput('assetName', e.target.value)} defaultValue={this.state.fieldValues.assetName}
                   className="string optional" type="text" name="asset[name]" id="asset_name"></input>
            <FormError formErrors={this.state.formErrors} fieldName="assetName" />
          </div>
        </label>
      </div>
    );
  }

  grossValueField(config = {}){
    return (
      <div key='gross-value' className={`${config.classNames} form-input integer optional asset_gross_value`}>
        <label className="form-control asset_gross_value">
          <div className="form-control__label">
            <span>Current value</span>
          </div>
          <div className="form-control__input">
            <input defaultValue={this.state.fieldValues.grossValue}
                   className="format-currency numeric integer optional"
                   type="text"
                   name="asset[gross_value]"
                   id="asset_gross_value"
                   readOnly={this.props.isLinked ? "readonly" : ""} >
            </input>
          </div>
        </label>
      </div>
    );
  }

  zeroInputField(input, id){
    let $input = $(input).closest('.js-asset-form').find(`#${id}`);
    $input.val(0);
  }

  monthlyContributionField(config = {}){
    return (
      <div key='monthly-contribution' className={`${config.classNames} form-input integer optional asset_monthly_contribution`}>
        <label className="form-control asset_monthly_contribution">
          <div className="form-control__label">
            <span>{config.labelText || "Total Monthly Contributions"}</span>
          </div>
          <div className="form-control__input">
            <input onChange={(e) => { this.zeroInputField(e.target, 'asset_monthly_income') }}
                   className="format-currency numeric integer optional"
                   type="text"
                   defaultValue={this.state.fieldValues.monthlyContribution}
                   name="asset[monthly_contribution]"
                   id="asset_monthly_contribution">
            </input>
          </div>
        </label>
      </div>
    );
  }

  employerMonthlyContributionField(config = {}){
    return (
      <div key='employer-monthly-contribution' className={`${config.classNames} form-input integer optional asset_monthly_contribution`}>
        <label className="form-control asset_monthly_contribution">
          <div className="form-control__label">
            <span>{config.labelText || "Total Employer Monthly Contributions"}</span>
          </div>
          <div className="form-control__input">
            <input onChange={(e) => { this.zeroInputField(e.target, 'asset_monthly_income') }}
                   className="format-currency numeric integer optional"
                   type="text"
                   defaultValue={this.state.fieldValues.employerMonthlyContribution}
                   name="asset[employer_monthly_contribution]"
                   id="employer_monthly_contribution">
            </input>
          </div>
        </label>
      </div>
    );
  }

  monthlyIncomeField(config = {}){
    return (
      <div key='monthly-income' className={`${config.classNames} form-input integer optional asset_monthly_income`}>
        <label className="form-control asset_monthly_income">
          <div className="form-control__label">
            <span>{config.labelText || "How much are you withdrawing monthly?"}</span>
          </div>
          <div className="form-control__input">
            <input className="format-currency numeric integer optional"
                   onChange={(e) => { this.zeroInputField(e.target, 'asset_monthly_contribution') }}
                   type="text"
                   defaultValue={this.state.fieldValues.monthlyIncome}
                   name="asset[monthly_income]"
                   id="asset_monthly_income">
            </input>
          </div>
        </label>
      </div>
    );
  }

  currencyFields(config = {}){
    return (
      <div key='asset-currency-fields' className="inline-radio">
        <label className='radio-button-label'>Select a currency</label>
        <fieldset>
           <div className={`${config.classNames} form-input radio_buttons`}>
             <fieldset className="form-controls">
               <div className="form-controls__controls">
                  {this.state.currencies.map(currency => {
                    return (
                      <label key={currency} className="form-control" htmlFor={`${currency}-${this.props.assetId}`}>
                         <input className="radio_buttons" onChange={(e) => this.setSelectedCurrency(e)}
                           type="radio" value={currency} defaultChecked={this.state.selectedCurrency == currency} id={`${currency}-${this.props.assetId}`} name="asset[currency]"/>
                         <span className="form-control__indicator"></span>
                         <span className="form-control__label">{currency.toUpperCase()}</span>
                      </label>
                   );
                  })}
               </div>
             </fieldset>
           </div>
         </fieldset>
      </div>
    );
  }

  interestRateValidator(inputValue, maxValue, assetType){
    this.setState({
      interestRateWarning: assetType == 'moneyMarket' && inputValue > maxValue
    })
    this.props.changeAssetInterestRate(inputValue)
  }

  interestRateFields(config = {}){
    return (
      <div key='interest-rate' className={`${config.classNames} ${this.state.interestRateWarning ? 'has-warning' : ''} form-input integer optional asset_interest_rate`}>
        <label className="form-control asset_interest_rate">
          <div className="form-control__label">
            <span>{config.labelText || "What is the expected return rate?"}</span>
          </div>
          <div className="form-control__input">
            <input className="numeric integer optional"
                   type="number"
                   defaultValue={this.props.defaultInterestRate}
                   onChange={(e) => this.interestRateValidator(e.target.value, config.maxValue, config.assetType)}
                   name="interest_rate_percentage"
                   id="asset_interest_rate">
            </input>
            <p className="form-input__warning">
              { config.warningMessage }
            </p>
          </div>
        </label>
      </div>
    );
  }

  actualBondInterestRate(rate) {
    return ((parseFloat(rate) + this.props.primeInterestRate) * 100).toFixed(2);
  }

  defaultBondInterestRate() {
    if (this.state.fieldValues.interestRate) {
      return this.actualBondInterestRate(this.state.fieldValues.interestRate);
    } else {
      return (this.props.primeInterestRate * 100).toFixed(2);
    }
  }

  bondInterestRateFields(config = {}){
    return (
      <div key='interest-rate' className={`${config.classNames} form-input integer optional asset_interest_rate`}>
        <label className="form-control asset_interest_rate">
          <div className="form-control__label">
            <span>{`What is the interest rate on your bond? (Prime = ${this.props.primeInterestRate * 100}%)`}</span>
          </div>
          <div className="form-control__input">
            <input className="numeric integer optional"
                   type="number"
                   defaultValue={this.defaultBondInterestRate()}
                   onChange={(e) => this.interestRateValidator(e.target.value, config.maxValue, config.assetType)}
                   name="interest_rate_percentage"
                   id="asset_interest_rate">
            </input>
          </div>
        </label>
      </div>
    );
  }

  liabilityFields(config = {}){
    return (
      <div key='asset-liability' className={`${config.classNames} form-input integer optional asset_liability`}>
        <label className="form-control asset_liability">
          <div className="form-control__label">
            <span>Liability value (debt)</span>
          </div>
          <div className="form-control__input">
            <input className="format-currency numeric integer optional"
                   type="text"
                   defaultValue={this.state.fieldValues.liability}
                   name="asset[liability]"
                   id="asset_liability">
            </input>
          </div>
        </label>
      </div>
    );
  }

  termOfDebtFields(config = {}) {
    return (
      <div key='asset-term-of-debt' className={`${config.classNames} form-input integer optional asset_term_of_debt`}>
        <label className="form-control asset_term_of_debt">
          <div className="form-control__label">
            <span>Terms of debt left (years)</span>
          </div>
          <div className="form-control__input">
            <input className="numeric integer optional"
                   type="number"
                   defaultValue={this.state.fieldValues.termOfDebt}
                   name="asset[term_of_debt]"
                   id="asset_term_of_debt">
            </input>
          </div>
        </label>
      </div>
    );
  }

  monthlyProfitFields(config = {}){
    return (
      <div key='asset-monthly-profit' className={`${config.classNames} integer optional asset_monthly_profit`}>
        <label className="form-control asset_monthly_profit">
          <div className="form-control__label">
            <span>Monthly profit / loss (after expenses including bond)</span>
          </div>
          <div className="form-control__input">
            <input className="format-currency numeric integer optional"
                   type="text"
                   defaultValue={this.state.fieldValues.monthlyIncome || 0}
                   name="asset[monthly_income]"
                   id="asset_monthly_profit">
            </input>
          </div>
        </label>
      </div>
    );
  }

  baseCostFields(config = {}){
    return (
      <div key='asset-base-cost' className={`${config.classNames} integer optional asset_base_cost`}>
        <label className="form-control asset_base_cost">
          <div className="form-control__label">
            <span>How much has been contributed to this asset?</span>
          </div>
          <div className="form-control__input">
            <input className="format-currency numeric integer optional"
                   type="text"
                   defaultValue={this.state.fieldValues.baseCost || 0}
                   name="asset[base_cost]"
                   id="asset_base_cost">
            </input>
          </div>
        </label>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderSelectedFields()}
      </div>
    )
  }
}
